export default "__VITE_ASSET__DTxX6vNN__"